import { render, staticRenderFns } from "./Dedication.vue?vue&type=template&id=0ad59e13&"
import script from "./Dedication.vue?vue&type=script&lang=js&"
export * from "./Dedication.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports